<template>
  <div
    class="checkblock"
    :class="{ 'is-checked': value, 'is-single': single }"
    @click="$emit('input', !value)"
  >
    <input type="checkbox" :value="value" />
    <p class="checkblock-label">
      <slot></slot>
    </p>
    <span class="checkblock-toggle" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    single: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
